export default "__VITE_ASSET__BS3mLR3I__"